package nl.appstuff.padelchecker.site

import kotlinx.browser.window

enum class WebPlatform {
    ANDROID, IOS, OTHER
}

fun platform(): WebPlatform {
    val userAgent = window.navigator.userAgent.lowercase()

    return when {
        "android" in userAgent -> WebPlatform.ANDROID
        "iphone" in userAgent || "ipad" in userAgent || "ipod" in userAgent -> WebPlatform.IOS
        else -> WebPlatform.OTHER
    }
}